import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DeviceComponent } from "./deviceList/deviceadd.component";
import { UserComponent } from "./users/user.component";
import { ReasonsComponent } from "./reasons/reasons.component";
import { CustomerInfoComponent } from "./customer_info/customer_info.component";
import { shiftInfioComponent } from "./shift_info/shift_info.component";
import { ProductionPlanningComponent } from "./production-planning/production-planning.component";
import { ProgramListComponent } from "./program-list/program-list.component";
import { DeportmentComponent } from "./deportment/deportment.component";
import { CostConfigComponent } from "./cost-config/cost-config.component";
import { SupervisorMappingComponent } from "./supervisor-mapping/supervisor-mapping.component";
import { FormulaConfigComponent } from "./formula-config/formula-config.component";
import { EscalationComponent } from "./escalation/escalation.component";
import { CategoryComponent } from "./category/category.component";
import { ProcessListComponent } from "./process-list/process-list.component";
import { WorkorderComponent } from "./workorder/workorder.component";
import { JobOrderComponent } from "./job-order/job-order.component";
import { OperatorMappingComponent } from "./operator-mapping/operator-mapping.component";

const routes: Routes = [
  {
    path: "reasons",
    component: ReasonsComponent,
  },
  {
    path: "user",
    component: UserComponent,
  },
  {
    path: "device",
    component: DeviceComponent,
  },
  {
    path: "department",
    component: DeportmentComponent,
  },
  {
    path: "shift",
    component: shiftInfioComponent,
  },
  {
    path: "customer",
    component: CustomerInfoComponent,
  },
  {
    path: "programList",
    component: ProgramListComponent,
  },
  {
    path: "productionPlanning",
    component:ProductionPlanningComponent
  },
  {
    path: "escalation",
    component:EscalationComponent
  },
  {
    path: "costConfig",
    component:CostConfigComponent
  },
  {
    path: "supervisorMapping",
    component:SupervisorMappingComponent
  },
  {
    path: "operatorMapping",
    component:OperatorMappingComponent
  },
   {
    path: "formula",
    component:FormulaConfigComponent
  },
  {
    path: "category",
    component:CategoryComponent
  },
   {
    path: "processlist",
    component:ProcessListComponent
  },
   {
    path: "jobOrder",
    component:JobOrderComponent
  },
  {
    path: "workorder",
    component:WorkorderComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FormRoutingModule {}
